import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommControlPackets extends Layout {
    sourceMcPnetPackets: DataSource;
    textboxLastRecordProcessed: Textbox;
    textboxPacketId: Textbox;
    textboxPacketServiceType: Textbox;
    textboxVendor: Textbox;
}
